module.exports = __webpack_public_path__ + "img/t4-16.db3f8a8c.svg";